export type CategoryBreadcrumb = {
    title: string;
    id: string;
    depth: number;
};

export function safeParseBreadcrumbs(value: string | null | undefined): CategoryBreadcrumb[] | undefined {
    try {
        return value ? JSON.parse(value) : undefined;
    } catch {
        return undefined;
    }
}
